import cn from 'classnames';
import React from 'react';
import Image from 'next/image';

import CTA from 'react-scale/components/elements/cta';

const Hero = ({ theme, icon, title, subtitle, cta, scaleLogo = true }) => (
  <div className="overflow-hidden">
    <div className="container">
      <div className="flex flex-col py-14 md:py-24 md:flex-row">
        {icon && (
          <div className="shrink-0">
            <div className="relative w-12 h-12 mb-4 md:w-32 md:h-32 md:mb-0 md:mt-6">
              <Image src={icon.url} layout="fill" alt={icon.alt} quality="100" />
            </div>
          </div>
        )}
        <div
          className={cn(
            icon && 'md:pl-12',
            'flex flex-col flex-wrap w-full md:flex-row lg:items-center lg:justify-between'
          )}
        >
          <div>
            {scaleLogo && (
              <img
                src="/static/images/logos/logo-true-gray-400.svg"
                alt="Scale Logo"
                className="h-6 mt-4 md:h-12 md:pt-4 mb-2"
              />
            )}

            <div>
              <h2 className="text-5xl text-white font-aeonik md:text-6xl">{title}</h2>
              {subtitle && (
                <p className="mt-4 text-lg text-neutral-300 md:text-xl lg:max-w-xl">{subtitle}</p>
              )}
            </div>
          </div>
          <div>
            <CTA theme={theme} cta={cta} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

Hero.defaultProps = {
  title: 'Mapping',
  scaleLogo: true,
  cta: {
    buttons: [
      {
        text: 'Get Started',
        href: 'https://dashboard.scale.com/signup',
        type: 'primary'
      },
      {
        text: 'Book a Demo',
        href: '/sales',
        type: 'secondary'
      }
    ]
  }
};

export default Hero;
